import React from 'react'

import { Box, Button, Icon, RadioButton, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { ItemType } from 'modules/processes/hooks/types'

interface Props {
  title: string
  description: string
  value: ItemType | string
  itemType: ItemType | undefined
  isUpgradeSelector?: boolean
  selectedOnTypes?: ItemType[]
  onSelect: () => void
  openUpgradeModal?: () => void
}

const ItemCard = ({
  title,
  description,
  value = '',
  itemType = undefined,
  isUpgradeSelector = false,
  onSelect,
  openUpgradeModal,
  selectedOnTypes,
}: Props) => {
  const isChecked =
    value === itemType || !!(selectedOnTypes && selectedOnTypes.includes(value as ItemType))
  const [hover, setHover] = React.useState(false)

  const onClick = () => {
    if (isUpgradeSelector) return
    onSelect()
  }

  const onHover = (val: boolean) => {
    if (isUpgradeSelector) return

    setHover(val)
  }

  return (
    <Box
      onClick={onClick}
      alignItems="flexStart"
      flexDirection="row"
      width="full"
      justifyContent="spaceBetween"
      borderRadius={{ all: 'abs016' }}
      paddingX="s24"
      paddingY="s16"
      gap="s24"
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
      border={{
        all: {
          color: isChecked ? 'grey1000' : hover ? 'grey600' : 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      cursor="pointer"
    >
      <Box gap="s8">
        <Box flexDirection="row">
          {isUpgradeSelector && <Icon.Medium color="tangerine1000" icon="lock-locked" />}
          <Text.Normal weight="semibold" color="grey1000">
            {title}
          </Text.Normal>
        </Box>
        <Text.Normal>{description}</Text.Normal>
        {isUpgradeSelector && (
          <Button onClick={openUpgradeModal} type="upgrade">
            {i18n.t('processes.process_settings.upgrade_modal.cta')}
          </Button>
        )}
      </Box>
      <RadioButton
        size="medium"
        onChange={() => null}
        value={value}
        disabled={isUpgradeSelector}
        checked={isChecked}
      />
    </Box>
  )
}

export default ItemCard
